export default "__VITE_ASSET__viS0Zggy__"